import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ShopByColorLink from '~/layout/components/ShopByColorLink';
import featureNames from '~/shared/constants/featureFlags';
import useHasFeature from '~/shared/utils/useHasFeature';
import {
  AttributeFieldTypes,
  ProductSelectorType,
  ProductAttributeSelector,
  useProductAttributeFieldType,
  useFilterFieldLabels,
  useOptionLabels,
  useProductDetailSelectionState,
} from '~/techstyle-shared/react-components';

const Wrapper = styled.div`
  ${({ $labelTextStyles }) => $labelTextStyles};
  margin: 6px 0;
`;

const SelectedInfoText = styled.span`
  ${({ $infoTextStyles }) => $infoTextStyles};
  margin-left: 4px;
`;

export const ProductDetailLabelWithContext = ({ field, ...rest }) => {
  return (
    <ProductAttributeSelector field={field}>
      {({ attribute, selectedOption }) => {
        return (
          <ProductDetailLabel
            attribute={attribute}
            selectedOption={selectedOption}
            field={field}
            {...rest}
          />
        );
      }}
    </ProductAttributeSelector>
  );
};

ProductDetailLabelWithContext.propTypes = {
  field: PropTypes.string,
};

export const ProductDetailLabel = ({
  displayFilterField = true,
  infoTextStyles,
  labelTextStyles,
  attribute = {},
  selectedOption = {},
  field,
  isSummary = false,
  ...rest
}) => {
  const fieldLabelCtx = useFilterFieldLabels();
  const optionLabelCtx = useOptionLabels();
  const { swatchTypesAvailable } = useProductDetailSelectionState();
  const enableSwatchTypes =
    swatchTypesAvailable && swatchTypesAvailable.length > 1;
  const ColorField = useProductAttributeFieldType(AttributeFieldTypes.COLOR);
  let selector = {};
  const isShopByColorEnabled = useHasFeature(featureNames.SHOP_BY_COLOR);
  const colorField = field === ColorField;
  if (colorField) {
    selector = { selectorType: ProductSelectorType.SWATCH };
  } else {
    selector = { selectorType: ProductSelectorType.GRID };
  }
  const displayShopByColorLink =
    isShopByColorEnabled && colorField && !enableSwatchTypes;

  return (
    <Wrapper $labelTextStyles={labelTextStyles} {...rest}>
      {displayFilterField && fieldLabelCtx.renderLabel(attribute)}
      {displayFilterField && ': '}
      <SelectedInfoText $infoTextStyles={infoTextStyles}>
        {optionLabelCtx.renderLabel(
          attribute,
          selectedOption,
          selector,
          isSummary
        )}
      </SelectedInfoText>
      {displayShopByColorLink && (
        <ShopByColorLink masterProductId={selectedOption.masterProductId} />
      )}
    </Wrapper>
  );
};

ProductDetailLabel.propTypes = {
  attribute: PropTypes.object,
  displayFilterField: PropTypes.bool,
  field: PropTypes.string,
  infoTextStyles: PropTypes.any,
  isSummary: PropTypes.bool,
  labelTextStyles: PropTypes.any,
  selectedOption: PropTypes.object,
};
